import { render, staticRenderFns } from "./icon-alarm-folder.vue?vue&type=template&id=599fba1b&"
import script from "./icon-alarm-folder.vue?vue&type=script&lang=ts&"
export * from "./icon-alarm-folder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports